<template>
  <el-dialog title="选择用户" v-loading="selectLoading" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false" top="5%">
   <div>
    <sy-baselist
      :filters="filters"
      :hideAdd="true"
      :hideEdit="true"
      :hideDel="true"
      :showSelect="true"
      @onSelect="onSelect"
      listUrl="server/system/User.ashx?cmd=GetUserList"
    >
      <el-table-column prop="code" label="登录名" width="100" sortable>
      </el-table-column>
      <el-table-column prop="name" label="用户名" width="150" sortable>
      </el-table-column>
      <el-table-column prop="note" label="备注" width="200" sortable>
      </el-table-column>
    </sy-baselist>
   </div>
  </el-dialog>
</template>

<script>
  import util from '../../common/util'
  export default {
    data(){
      return {
        selectLoading:false,
        FRoleID:0,
        editFormVisible:false,
        filters: [{type: "string",name:"code",text:"工号", value: ""}
          ,{type: "string",name:"name",text:"用户名", value: ""}]
      }
    },
    methods:{
      switchLoading(flag){
        this.selectLoading = flag;
      },
      _openAdd(row) {
        this.editFormVisible = true
        this.FRoleID = row.roleId
      },
      onSelect(row){
        let form={
          id:0,
          roleId:this.FRoleID,
          userId:row.id,
          name:row.name
        }
        util.post("server/system/Role.ashx?cmd=SaveRoleUser",form,this.switchLoading,result=> {
          this.editFormVisible = false
          this.$emit("onSaveSuc",row)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/system/User_Select.vue